<template>
    <div style="height: 100%">
        <div v-if="params.data.status < 2 && moment(params.value).isBefore(moment())" style="height: 100%">
            <vs-chip class="mr-3" style="height: 60%; top:20%" color="danger">{{ moment(params.value).format('DD/MM/YYYY HH:mm')}}</vs-chip>
        </div>
        <div v-else>
            {{ moment(params.value).format('DD/MM/YYYY HH:mm')}}
        </div>
    </div>
</template>
<script>
    import Vue from "vue";

    export default Vue.extend({
    });

</script>
